const rules = {
  account: {
    presence: { allowEmpty: false, message: "账号不能为空白" },

    format: {
      pattern: /^([a-zA-Z0-9]+|[^\s@]+@[^\s@]+\.[^\s@]+|\+[1-9]\d{1,14})$/,
      message: "请输入有效的邮箱或手机号",
    },
  },
  username: {
    presence: { allowEmpty: false, message: "账号不能为空白" },
    format: {
      pattern: /[a-zA-Z0-9]+/,
      message: "账号只能为英数组合",
    },
    length: {
      maximum: 18,
      minimum: 6,
      message: "账号长度必须是6至18位之间",
    },
  },
  password: {
    presence: { allowEmpty: false, message: "密码不能为空白" },
    format: {
      pattern: /^(?=.*[a-zA-Z])(?=.*\d)[\x21-\x7E]{8,16}$/,
      message: "密码需为8-16位且至少包含字母和数字，可使用常见符号",
    },
    length: {
      minimum: 8,
      maximum: 16,
      message: "密码长度必须是8至16位之间",
    },
  },
  channelname: {
    presence: { allowEmpty: false, message: "名称不能为空白" },
    length: {
      maximum: 20,
      minimum: 3,
      message: "长度必须是3至20位之间",
    },
  },
  code: {
    presence: { allowEmpty: false, message: "验证码不能为空白" },
  },
  email: {
    presence: { allowEmpty: false, message: "电子邮箱不能为空白" },
    format: {
      pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
      message: "需符合电子邮箱格式",
    },
  },
  displayname: {
    presence: { allowEmpty: false, message: "昵称不能为空白" },
    nickname: {
      message: "昵称超过长度",
    },
  },
  contact_displayname: {
    contact_nickname: {
      message: "备注超过长度",
    },
  },
  contact_note: {
    contact_note: {
      message: "描述超过长度",
    },
  },
  accusationType: {
    presence: { allowEmpty: false, message: "请选择举报理由" },
  },
  phone: {
    presence: { allowEmpty: false, message: "手机号不能为空白" },
    format: {
      pattern: /^1[3-9]\d{9}$/,
      message: "需符合手机号格式",
    },
  },
  // wechatAndAlipayAccount: {
  //   presence: { allowEmpty: false, message: "账号不能为空白" },
  //   format: {
  //     pattern: /[a-zA-Z0-9]+/,
  //     message: "账号只能为英数组合",
  //   },
  // },
  alipay: {
    presence: { allowEmpty: false, message: "账号不能为空白" },
    format: {
      pattern: /(?:1[3-9]\d{9}|[a-zA-Z\d._-]*@[a-zA-Z\d.-]{1,10}\.[a-zA-Z\d]{1,20})$/,
      message: "需符合支付宝账号格式",
    },
  },
  wechat: {
    presence: { allowEmpty: false, message: "账号不能为空白" },
    format: {
      pattern: /^[a-zA-Z-][a-zA-Z\d_-]{5,19}$/,
      message: "需符合微信账号格式",
    },
  },
}

export default rules
